var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-xs-center"},[_c('h3',{staticClass:"display-2 pt-4"},[_vm._v(_vm._s(_vm.message))]),_c('v-btn',{on:{"click":function($event){return _vm.reloadTest()}}},[_c('v-icon',[_vm._v("refresh")]),_vm._v(" Retry")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }